import { Avatar, Button, Stack, Typography } from "@mui/material";
import LinkOffIcon from "@mui/icons-material/LinkOff";
import { ConfirmationDialog } from "@/components/Dialog/ConfirmationDialog";

interface ShareNotOwnerDialogProps {
  open: boolean;
  onClose: () => void;
  onSaveAsNew: () => void;
}

export const ShareNotOwnerDialog: React.FC<ShareNotOwnerDialogProps> = ({
  open,
  onClose,
  onSaveAsNew,
}) => (
  <ConfirmationDialog
    title="Share Segment"
    open={open}
    actions={
      <Stack
        direction="row"
        spacing={1}
        width="100%"
        justifyContent="space-between"
        padding={2}
      >
        <Button
          color="secondary"
          variant="outlined"
          onClick={onClose}
          data-testid="share-not-owner-cancel-btn"
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onSaveAsNew}
          data-testid="share-not-owner-save-as-new-btn"
        >
          Save as New Segment
        </Button>
      </Stack>
    }
    onClose={onClose}
  >
    <Stack minWidth={500} alignItems="center" gap={2} padding={2}>
      <Avatar sx={{ bgcolor: "#ffe0b2", color: "black" }}>
        <LinkOffIcon />
      </Avatar>
      <Typography
        fontWeight={600}
        fontSize="20px"
        mb={1}
        data-testid="share-not-owner-title"
      >
        Only the owner can share this segment
      </Typography>
      <Typography>
        Creating or updating this segment's shared link is limited to its owner.
        Save a copy to your own segments to share it.
      </Typography>
      <Typography>
        The copy keeps the segment's filters. Spend categories and tier settings
        start from the settings in your own browser.
      </Typography>
    </Stack>
  </ConfirmationDialog>
);
